import { render, staticRenderFns } from "./TableBlueLabelGame.vue?vue&type=template&id=2353adca&scoped=true&"
import script from "./TableBlueLabelGame.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelGame.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelGame.vue?vue&type=style&index=0&id=2353adca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353adca",
  null
  
)

export default component.exports